import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getToken, completeBoGOrder } from './bog.js';

const Return = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(true);
    const [status, setStatus] = useState(null);
    const [error, setError] = useState(null);
    const [message, setMessage] = useState('Processing your payment...');

    useEffect(() => {
        const processPayment = async () => {
            try {
                // Get order_reference from URL
                const orderReference = searchParams.get('order_reference');
                
                if (!orderReference) {
                    setError('Order reference not found in URL');
                    setLoading(false);
                    return;
                }

                console.log('Processing payment for order_reference:', orderReference);

                // Complete the payment - this will update trees to sponsored
                try {
                    const result = await completeBoGOrder(null, orderReference);
                    
                    if (result.success) {
                        setStatus('success');
                        setMessage('Payment completed successfully! Your trees have been sponsored.');
                        console.log('Payment completed:', result);
                        
                        // Redirect to home after 3 seconds
                        setTimeout(() => {
                            navigate('/');
                        }, 3000);
                    } else {
                        setStatus('error');
                        setError(result.error || 'Payment completion failed');
                    }
                } catch (err) {
                    console.error('Error completing payment:', err);
                    setStatus('error');
                    setError(err.message || 'Failed to complete payment');
                }
            } catch (err) {
                console.error('Error processing payment return:', err);
                setError(err.message || 'An error occurred');
            } finally {
                setLoading(false);
            }
        };

        processPayment();
    }, [searchParams, navigate]);

    if (loading) {
        return (
            <section id="success" style={{ padding: '2rem', textAlign: 'center' }}>
                <p>{message}</p>
            </section>
        );
    }

    if (error) {
        return (
            <section id="error" style={{ padding: '2rem', textAlign: 'center' }}>
                <p style={{ color: 'red' }}>Error: {error}</p>
                <p>Please contact support if the payment was successful.</p>
            </section>
        );
    }

    if (status === 'success') {
        return (
            <section id="success" style={{ padding: '2rem', textAlign: 'center' }}>
                <h2>Payment Successful!</h2>
                <p>
                    We appreciate your business! Your trees have been sponsored.
                    A confirmation email will be sent to your email address.
                </p>
                <p>
                    If you have any questions, please email <a href="mailto:orders@example.com">orders@example.com</a>.
                </p>
                <p>Redirecting to home page...</p>
            </section>
        );
    }

    return (
        <section id="success">
            <p>
                We appreciate your business! A confirmation email will be sent to your email address.
                If you have any questions, please email <a href="mailto:orders@example.com">orders@example.com</a>.
            </p>
        </section>
    );
}

export default Return;
